export const environment = {
  production: true,
  apiUrl: 'https://dev-api.trackngrow.eu',
  tolgeeApiUrl: 'https://tolgee.trackngrow.eu/',
  tolgeeApiKey: 'tgpak_gfpwo3ldnbvhe4lqgzqwe4brmq2w6mlfnjzwg5dhnntxm',
  canny: 'https://trackngrow.canny.io',
  novu: {
    applicationIdentifier: 'NpXs6e04SgHn',
  },
}; 